module.exports = __webpack_public_path__ + "img/picture_43.684782d8.png";